import { lead } from './lead';
import type { Brand } from './types';

export const appiq: Brand = { ...lead, key: 'appiq' };
